import React, { useEffect, useState } from "react";
import { MdAddCircleOutline } from "react-icons/md";
import { validateObjectByFields } from "../../../../util/validate";
import { useUIContext } from "../../../../context/UIContext";
import { useTranslation } from "react-i18next";
import EmptySpecialSubjectContentTr from "./EmptySpecialSubjectContentTr";

export default function SpecialSubjectContentTr({
  item,
  hideAddBtn,
  setHideAddBtn,
  items,
  setRows,
  setItems,
}) {
  const { t } = useTranslation();
  const { handleToastCenterTop } = useUIContext();

  const [updateRow, setUpdateRow] = useState(item);
  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [isAddingRow, setIsAddingRow] = useState(false);
  const [validateStyles, setValidateStyles] = useState({});

  // item prop이 변경되면 updateRow 상태도 동기화
  useEffect(() => {
    setUpdateRow(item);
  }, [item]);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setUpdateRow((prev) => ({ ...prev, [name]: value }));

    // 입력 요소가 textarea일 경우 높이 자동 조정
    if (type === "textarea") {
      const textarea = e.target;
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  const handleAddTr = () => {
    setHideAddBtn(true);
    setIsAddingRow(true);
  };

  const handleSave = () => {
    const fieldsToValidate = [
      {
        key: "order",
        type: "number",
        required: true,
        name: t("common.labels.order") || "순서",
      },
    ];

    // hierarchy_level 1인 경우 content는 최상위/영역 컬럼에 표시되므로 필수
    // hierarchy_level 2인 경우 field와 content 모두 필수
    if (updateRow.hierarchy_level === 2) {
      fieldsToValidate.push(
        {
          key: "field",
          type: "string",
          required: true,
          name: t("teacher.lessonRelated.area") || "영역",
        },
        {
          key: "content",
          type: "string",
          required: true,
          name: t("teacher.lessonRelated.content") || "내용",
        }
      );
    }

    setValidateStyles({});

    const errorObject = validateObjectByFields(updateRow, fieldsToValidate);
    const typeErrors = Object.values(errorObject.type || {});
    const requiredErrors = Object.values(errorObject.required || {});
    const allErrors = typeErrors.concat(requiredErrors);
    const errorMessageString = allErrors.join("\n");

    if (allErrors.length > 0) {
      const newStyles = {};
      Object.keys(errorObject.type).forEach((key) => (newStyles[key] = true));
      Object.keys(errorObject.required).forEach(
        (key) => (newStyles[key] = true)
      );
      setValidateStyles(newStyles);
      handleToastCenterTop(errorMessageString);
      return;
    }

    setIsSaving(true);

    // 상태 업데이트
    setItems((prev) =>
      prev.map((i) => (i.id === updateRow.id ? updateRow : i))
    );
    setRows((prev) => prev.map((i) => (i.id === updateRow.id ? updateRow : i)));

    setIsSaving(false);
    handleToastCenterTop(
      t("common.messages.savedSuccessfully") || "성공적으로 저장되었습니다."
    );
  };

  const handleDelete = (e) => {
    const { name } = e.target;
    const { id } = updateRow;

    if (name === "delete") {
      setConfirmDelete(true);
    } else {
      const hasChild = items.some((item) => item.parent_id === id);

      if (hasChild) {
        handleToastCenterTop(
          t("teacher.lessonRelated.deleteMessage") ||
            "하위 항목이 있어 삭제할 수 없습니다."
        );
        return;
      }

      setConfirmDelete(false);
      setIsDeleting(true);

      // 상태에서 삭제
      setItems((prev) => prev.filter((i) => i.id !== id));
      setRows((prev) => prev.filter((i) => i.id !== id));

      setIsDeleting(false);
    }
  };

  return (
    <React.Fragment>
      <tr>
        <th scope="row" className="text-center p-0">
          {updateRow?.hierarchy_level || ""}
        </th>
        <td
          className="changePaddings pt-0 pb-0"
          style={{
            paddingLeft: `${(updateRow?.hierarchy_level - 1) * 20}px`,
          }}
        >
          <div className="d-flex">
            {updateRow?.hierarchy_level > 1 && (
              <span
                style={{
                  fontSize: "24px",
                  color: "gray",
                  verticalAlign: "top",
                  display: "inline-block",
                  lineHeight: "1",
                  paddingTop: "0px",
                }}
              >
                ㄴ
              </span>
            )}
            {updateRow?.hierarchy_level === 1 ? (
              <input
                type="text"
                className="input-like-span ms-2"
                name="field"
                value={updateRow?.field || ""}
                onChange={handleChange}
                placeholder="최상위"
                required
                style={{
                  backgroundColor: validateStyles?.field ? "pink" : undefined,
                }}
              />
            ) : (
              <input
                type="text"
                className="input-like-span ms-2"
                name="field"
                value={updateRow?.field || ""}
                onChange={handleChange}
                placeholder="영역"
                required
                style={{
                  backgroundColor: validateStyles?.field ? "pink" : undefined,
                }}
              />
            )}
          </div>
        </td>
        <td className="p-0">
          {updateRow?.hierarchy_level === 2 ? (
            <textarea
              className="input-like-span pt-1 pb-1"
              name="content"
              value={updateRow?.content || ""}
              onChange={handleChange}
              rows={1}
              required
              style={{
                backgroundColor: validateStyles?.content ? "pink" : undefined,
              }}
            />
          ) : (
            <span className="text-muted" style={{ fontSize: "0.8rem" }}>
              -
            </span>
          )}
        </td>
        <td className="p-0">
          <input
            type="number"
            className="input-like-span ms-2"
            value={updateRow?.order || ""}
            name="order"
            onChange={handleChange}
            required
            style={{
              backgroundColor: validateStyles?.order ? "pink" : undefined,
            }}
          />
        </td>

        {updateRow?.hierarchy_level < 2 ? (
          <td className="text-center align-middle p-0 m-0">
            {!hideAddBtn && (
              <MdAddCircleOutline
                className="p-0 m-0"
                role="button"
                size={25}
                color="blue"
                onClick={handleAddTr}
              />
            )}
          </td>
        ) : (
          <td className="text-center align-middle p-0 m-0"></td>
        )}
        <td className="p-0">
          {isDeleting ? (
            <button type="button" className="btn btn-sm btn-danger" disabled>
              {t("common.status.deleting")}..
            </button>
          ) : confirmDelete ? (
            <React.Fragment>
              <button
                type="button"
                className="btn btn-sm btn-danger"
                name="confirm"
                onClick={handleDelete}
              >
                {t("common.labels.execute") || "실행"}
              </button>
              <button
                type="button"
                onClick={() => setConfirmDelete(false)}
                className="btn btn-sm btn-secondary ms-1"
              >
                {t("common.labels.cancel") || "취소"}
              </button>
            </React.Fragment>
          ) : (
            <button
              type="button"
              className="btn btn-sm btn-warning"
              name="delete"
              onClick={handleDelete}
            >
              {t("common.labels.delete") || "삭제"}
            </button>
          )}
          {isSaving ? (
            <button className="btn btn-sm btn-primary ms-1" disabled>
              {t("common.status.saving")}
            </button>
          ) : (
            <button
              type="button"
              onClick={handleSave}
              className="btn btn-sm btn-primary ms-1"
            >
              {t("common.labels.save") || "저장"}
            </button>
          )}
        </td>
      </tr>
      {isAddingRow && (
        <EmptySpecialSubjectContentTr
          setHideAddBtn={setHideAddBtn}
          setIsAddingRow={setIsAddingRow}
          parentId={updateRow.id}
          parentHierarchyLevel={updateRow.hierarchy_level}
          items={items}
          setItems={setItems}
          setRows={setRows}
        />
      )}
    </React.Fragment>
  );
}
